    import { configureStore } from "@reduxjs/toolkit";
    import authSlice from "./auth/authSlice";
    import LoginSlice from "./auth/LoginSlice";

    export const store = configureStore({
        reducer: {
            auth: authSlice,
            login: LoginSlice
        },
    })